<template>
  <v-main>
    <v-container fluid>
      <!-- Generamos el AppBar con las distintas acciones -->
      <v-app-bar color="primary" dense dark style="border-radius: 5px">
        <!-- Crear una nuevo cliente -->
        <v-btn text @click="open_dialog_cliente">
          <v-icon>mdi-account-plus-outline</v-icon>
          <span class="appbar_button">{{ $t('Nuevo') }}</span>
        </v-btn>
        <!-- Exportar clientes -->
        <v-btn v-if="show_btn_exportar_clientes" :disabled="delay_exportar" text @click="exportar_clientes">
          <v-icon>mdi-cloud-download-outline</v-icon>
          <span class="appbar_button">{{ $t('Exportar') }}</span>
        </v-btn>
        <!-- Importar clientes -->
        <v-btn text @click="open_dialog_importar">
          <v-icon>mdi-cloud-upload-outline</v-icon>
          <span class="appbar_button">{{ $t('Importar') }}</span>
        </v-btn>
        <!-- Reordenar codigos de cliente -->
        <v-btn text @click="open_dialog_reordenar" v-if="$store.state.auth.user.tipo_empleado === 'admin'">
          <v-icon>mdi-reload</v-icon>
          <span class="appbar_button">{{ $t('Reordenar códigos') }}</span>
        </v-btn>
        <v-spacer />
          <v-btn icon href="https://www.youtube.com/playlist?list=PL2a9kD1kP16e4UCE3ZL4HARaUmQyPvpRG">
            <v-icon>mdi-video</v-icon>
          </v-btn>
      </v-app-bar>

      <v-expansion-panels focusable class="my-4">
        <v-expansion-panel>
          <v-expansion-panel-header class="titulo_buscador">
            <span>
              <v-icon large>mdi-magnify</v-icon>
              {{ $t("Buscar clientes") }}
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form>
              <v-row class="ma-1" align="center">
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <v-text-field :label="$t('Código de cliente')" v-model="selected_filters.code__icontains" outlined dense hide-details/>
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <v-text-field :label="$t('Nombre')" v-model="selected_filters.nombre__icontains" outlined dense hide-details/>
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <v-text-field :label="$t('Primer apellido')" v-model="selected_filters.apellido1__icontains" outlined dense hide-details/>
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <v-text-field :label="$t('Segundo apellido')" v-model="selected_filters.apellido2__icontains" outlined dense hide-details/>
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <v-text-field :label="$t('Teléfono')" v-model="selected_filters.telefono" outlined dense hide-details/>
                </v-col>
                <v-col>
                <v-row class="align-center">
                  <v-col cols="6" class="pt-3 pb-0">
                    <v-text-field
                        :label="$t('Imp. Min')"
                        :value="importeventas[0]"
                        v-model="importeventas[0]"
                        class="mt-0 pt-0"
                        hide-details
                        outlined
                        type="number"
                        height="auto"
                        dense
                    />
                  </v-col>
                  <v-col cols="6" class="pt-3 pb-0">
                    <v-text-field
                        :label="$t('Imp. Max')"
                        :value="importeventas[1]"
                        v-model="importeventas[1]"
                        class="mt-0 pt-0"
                        hide-details
                        outlined
                        height="auto"
                        type="number"
                        dense
                    />
                  </v-col>
                </v-row>
                </v-col>
              </v-row>
              <v-row class="ma-1" align="center">
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <CustomSelect
                      :items="[{text: $t('Si'), value: true}, {text:$t('No'), value: false}]"
                      v-model="selected_filters.activo"
                      :label="$t('Activo')"
                      multiple
                      chips
                      deletable-chips
                      outlined
                      dense
                  />
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <CustomSelect
                      :items="[{text: $t('Hombre'), value: 'h'}, {text: $t('Mujer'), value: 'm'}]"
                      v-model="selected_filters.sexo"
                      :label="$t('Sexo')"
                      multiple
                      chips
                      deletable-
                      outlined
                      dense
                  />
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <CustomSelect
                      :items="[{text: $t('Si'), value: false}, {text: $t('No'), value: true}]"
                      v-model="selected_filters.is_online"
                      :label="$t('Cliente online')"
                      multiple
                      chips
                      deletable-chips
                      outlined
                      dense
                  />
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <CustomSelect
                      :items="data_filters.categorias"
                      :label="$t('Categorías cliente')"
                      v-model="selected_filters.categorias"
                      multiple
                      chips
                      deletable-chips
                      outlined
                      dense
                      :unselect_all="true"
                  />
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <CustomSelect
                      :items="data_filters.servicios"
                      :label="$t('Servicios realizados')"
                      v-model="selected_filters.servicios"
                      multiple
                      chips
                      deletable-chips
                      outlined
                      dense
                      :unselect_all="true"
                  />
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <CustomSelect
                      :items="data_filters.productos"
                      :label="$t('Productos comprados')"
                      v-model="selected_filters.productos"
                      multiple
                      chips
                      deletable-chips
                      outlined
                      dense
                      :unselect_all="true"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-1" align="center">
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <CustomSelect
                      :items="[{text: $t('Si'), value: true}, {text: $t('No'), value: false}]"
                      :label="$t('Bonos activos')"
                      v-model="selected_filters.bonos"
                      multiple
                      chips
                      deletable-chips
                      outlined
                      dense
                  />
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <CustomSelect
                      :items="[{text: $t('Si'), value: true}, {text: $t('No'), value: false}]"
                      :label="$t('Cliente perdido')"
                      v-model="selected_filters.is_perdido"
                      multiple
                      chips
                      deletable-chips
                      outlined
                      dense
                  />
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <CustomSelect
                      :items="[{text: $t('Si'), value: true}, {text: $t('No'), value: false}]"
                      :label="$t('Cliente nuevo')"
                      v-model="selected_filters.nuevo"
                      multiple
                      chips
                      deletable-chips
                      outlined
                      dense
                  />
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <template>
                    <v-row>
                      <v-col cols="7">
                        <!--TODO: hacer los dos campos clearables (pero usar clearable ocupa demasiado espacio)-->
                        <v-select :label="$t('Mes Cumpleaños')" :items="meses" v-model="selected_filters.fecha_mes"
                                   dense outlined hide-details></v-select>
                      </v-col>
                      <v-col cols="5">
                        <v-select :label="$t('Día Cumpleaños')" v-model="selected_filters.fecha_dia"
                                  :items="generate_array_dias(31)" dense outlined hide-details>
                        </v-select>
                      </v-col>
                    </v-row>
                  </template>
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <CustomSelect
                      :items="[{text: $t('Si'), value: true}, {text: $t('No'), value: false}]"
                      :label="$t('Correo electrónico')"
                      v-model="selected_filters.email"
                      multiple
                      chips
                      deletable-chips
                      outlined
                      dense
                  />
                </v-col>
                <v-col cols="12" sm="4" md="2" class="pt-3 pb-0">
                  <CustomSelect
                      :items="[{text: $t('Si'), value: 1}, {text: $t('No'), value: 0}]"
                      :label="$t('RGPD')"
                      v-model="selected_filters.rgpd"
                      multiple
                      chips
                      deletable-chips
                      outlined
                      dense
                  />
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="pt-3 text-end">
                  <v-btn fab small right class="primary" @click="get_clientes">
                    <v-icon small>mdi-magnify</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>

    <BuscadorTabla :label="$t('Introducir nombre, primer apellido, segundo apellido, etc.')" @search_general="filter_clientes"/>

    <TablaClientes
        ref="tabla_clientes"
        :selected_filters="selected_filters"
        @on_click_ficha_cliente="go_to_ficha_cliente"
        @on_click_asociar_cliente="asociar_cliente"
        @on_click_desactivar_cliente="desactivar_cliente"
    />

    <!-- Dialogo de cliente con el formulario -->
    <FormCliente v-if="dialog_cliente"
                 v-model="dialog_cliente"
                 :item="current_cliente"
                 @on_save="on_save_cliente"/>
    <FormImportar v-if="dialog_importar"
                  v-model="dialog_importar"
                  @on_importar="on_importar"
    />
    <FormReordenarCodigos v-if="dialog_reordenar"
                          v-model="dialog_reordenar"
                          @refrescar_clientes="get_clientes"
    />
    <DialogAsignarClienteOnline v-if="dialog_asociar"
                                v-model="dialog_asociar"
                                :user_online="current_cliente_online"
                                @on_click_save="close_dialog_cliente_online"
    />
  </v-main>
</template>


<script>


export default {
  name: 'Clientes',

  data() {
    return {
      // Variables para el cuadro de busqueda
      selected_filters: {
        created: [],
        activo: [true]
      },
      delay_exportar: false,
      importeventas: [],
      meses: [
        { text: this.$t('Enero'), value: 1 },
        { text: this.$t('Febrero'), value: 2 },
        { text: this.$t('Marzo'), value: 3 },
        { text: this.$t('Abril'), value: 4 },
        { text: this.$t('Mayo'), value: 5 },
        { text: this.$t('Junio'), value: 6 },
        { text: this.$t('Julio'), value: 7 },
        { text: this.$t('Agosto'), value: 8 },
        { text: this.$t('Septiembre'), value: 9 },
        { text: this.$t('Octubre'), value: 10 },
        { text: this.$t('Noviembre'), value: 11 },
        { text: this.$t('Diciembre'), value: 12 }
      ],
      current_cliente: null,
      current_cliente_online: null,
      dialog_cliente: false,
      dialog_asociar: false,
      dialog_importar: false,
      dialog_reordenar: false,
      // Para rellenar los filtros
      data_filters: {
        categorias: [],
        servicios: [],
        productos: [],
        activo: [true]
      }
    }
  },

  methods: {
    async get_filters() {
      this.data_filters = await this.$store.dispatch('cliente/get_filters')
    },

    generate_filter(){
      this.selected_filters['importe_ventas__gte']= this.importeventas[0]
      this.selected_filters['importe_ventas__lte']= this.importeventas[1]

      this.selected_filters['is_active'] = this.selected_filters['activo'] ? this.selected_filters['activo'].join(",") : ''
      if(this.selected_filters['sexo'])
        this.selected_filters['sexo__in'] = this.selected_filters['sexo'].join(",")
      this.selected_filters['is_user_online'] = this.selected_filters['is_online'] ? this.selected_filters['is_online'].join(",") : ''
      if(this.selected_filters['categorias'])
        this.selected_filters['categoria__in'] = this.selected_filters['categorias'].join(",")
      if(this.selected_filters['servicios'])
        this.selected_filters['ventas__lineas_venta__servicio__in'] = this.selected_filters['servicios'].join(",")
      if(this.selected_filters['productos'])
        this.selected_filters['ventas__lineas_venta__producto__in'] = this.selected_filters['productos'].join(",")

      this.selected_filters['get_bonos_activos'] = this.selected_filters['bonos'] ? this.selected_filters['bonos'].join(","): ''
      if(this.selected_filters['is_perdido'])
        this.selected_filters['is_cliente_perdido'] = this.selected_filters['is_perdido'].join(",")
      this.selected_filters['is_nuevo'] = this.selected_filters['nuevo'] ? this.selected_filters['nuevo'].join(",") : ''

      this.selected_filters['get_fecha_nacimiento'] = ''
      if(this.selected_filters['fecha_dia'])
        this.selected_filters['get_fecha_nacimiento'] +=
            this.selected_filters['fecha_dia'] <= this.calc_day_cumpleanyos ?
                this.selected_filters['fecha_dia']:this.calc_day_cumpleanyos
      this.selected_filters['get_fecha_nacimiento'] += ','
      if(this.selected_filters['fecha_mes'])
        this.selected_filters['get_fecha_nacimiento'] += this.selected_filters['fecha_mes']

      if(this.selected_filters['email'])
        this.selected_filters['with_email'] = this.selected_filters['email'].join(",")
      if(this.selected_filters['rgpd'])
        this.selected_filters['is_agree_rgpd'] = this.selected_filters['rgpd'].join(",")
    },

    async get_clientes() {
      // Preparamos los filtros que enviamos a la api

      await this.generate_filter()

      await this.$refs.tabla_clientes.get_clientes()
    },

    go_to_ficha_cliente(cliente) {
      this.$router.push({name: 'ficha_cliente', params: {id: cliente.id}})
    },

    open_dialog_cliente() {
      // Hemos hecho clic en el botón nuevo cliente
      this.current_cliente = {}
      this.dialog_cliente = true
    },

    close_dialog_cliente_online() {
      // Hemos hecho clic en el botón nuevo cliente
      this.dialog_asociar = false
      this.get_clientes()
    },

    open_dialog_importar() {
      this.dialog_importar = true
    },

    open_dialog_reordenar() {
      this.dialog_reordenar = true
    },

    on_importar() {
      this.dialog_importar = false
      this.get_clientes()
    },

    async desactivar_cliente(cliente) {
      const resp = await this.$confirm(this.$t('¿Desactivar cliente?').toString())
      if (resp !== true) return;
      cliente.is_active = false
      try {
        await this.$store.dispatch('cliente/save', cliente)
        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name]),
        )
        await this.get_clientes()
      } catch (e) {
        this.$snotify.error(
          this.$t("Ha ocurrido un error"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    async asociar_cliente(cliente) {
      this.dialog_asociar = true
      this.current_cliente_online = cliente.user_online
    },

    async exportar_clientes() {
      if (this.delay_exportar) return
      try {
        this.delay_exportar = true
        await this.generate_filter()
        await this.$store.dispatch('cliente/exportar', this.selected_filters)
      } catch (e) {
        if (e.message.slice(e.message.length-3) === '418') {
          this.$snotify.info(
              this.$t("Exportación en curso. Se enviará al correo de tu centro cuando finalice. Tiempo estimado: 5 minutos."),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name]),
              {hideDuration: 500}
          )
        } else {
          this.$snotify.error(
              this.$t("Ha ocurrido un error"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
      }

      const func = () => {
        this.delay_exportar = false
      }
      setTimeout(func,3000);
    },
    generate_array_dias(dias){
      return [...Array(dias - 1 + 1).keys()].map(x => x + 1);
    },

    on_save_cliente(cliente){
      this.dialog_cliente = false
      setTimeout(() => {
        this.go_to_ficha_cliente(cliente)
      }, 2000)
    },

    filter_clientes(filter){
      this.selected_filters['search'] = filter
      this.get_clientes();
    }
  },

  mounted() {
    this.get_filters();
  },

  computed: {
    show_btn_exportar_clientes: function(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("exportar_clientes")) {
          return true
        }
      }
      return false
    },
    calc_day_cumpleanyos(){
        switch (this.selected_filters.fecha_mes){
          case 2:
            return 29
          case 4:
          case 6:
          case 9:
          case 11:
            return 30
          default:
            return 31
        }
    },
  },
  components: {
    BuscadorTabla: () => import('@/components/core/BuscadorTabla.vue'),
    TablaClientes: () => import('@/views/Clientes/Components/TablaClientes'),
    FormCliente: () => import('@/views/Clientes/Components/FormCliente'),
    FormImportar: () => import('@/views/Clientes/Components/ImportarClientes'),
    FormReordenarCodigos: () => import('@/views/Clientes/Components/FormReordenarCodigos'),
    DialogAsignarClienteOnline: () => import('@/views/Clientes/Components/DialogAsignarClienteOnline'),
  }
}
</script>
